import React from 'react';
import KickImage from 'Reuseables/KickImage';
import Styles from "./Header.module.scss";

interface IHeader {
  onSelect: (sort: string) => void;
  selectedSort: string;
}

const Header: React.FC<IHeader> = ({ onSelect, selectedSort }) => {
  return (
    <div className={Styles["section-card"]}>
      <div className={Styles["header"]}>
        <p>Market Update</p>
      </div>
      <div className={Styles["nmu-navs"]}>
        <div
          className={`${Styles["nmu-nav"]} ${Styles[selectedSort === '' ? 'selected' : '']}`}
          onClick={() => onSelect('')}
        >
          <p>Best Selling</p>
          <div className={Styles["selected-line"]} />
        </div>
        <div
          className={`${Styles["nmu-nav"]} ${Styles[selectedSort === 'gainer' ? 'selected' : '']}`}
          onClick={() => onSelect('gainer')}
        >
          <p>Gainer</p>
          <div className={Styles["selected-line"]} />
        </div>
        <div
          className={`${Styles["nmu-nav"]} ${Styles[selectedSort === 'loser' ? 'selected' : '']}`}
          onClick={() => onSelect('loser')}
        >
          <p>Loser</p>
          <div className={Styles["selected-line"]} />
        </div>
      </div>
    </div>
  );
};

Header.defaultProps = {
  onSelect: () => {}, 
  selectedSort: ""
}

export default Header